import { useMemo } from 'react';
import { styles } from '../../styles/ChemoRecordsStyles';
import { chemoTranslations } from './chemoTranslations';

const STATUS = {
    COMPLETED: 'completed',
    DRAFT: 'draft',
    IN_PROGRESS: 'in_progress'
};

const useChemoReportsList = (reports) => {
    const hasReports = useMemo(() => {
        return reports && reports.length > 0;
    }, [reports]);

    const getStatusStyle = (status) => {
        if (status === STATUS.COMPLETED) return styles.statusApproved;
        if (status === STATUS.DRAFT) return styles.statusPending;
        return styles.statusPending;
    };

    const getStatusLabel = (status) => {
        const labels = {
            [STATUS.COMPLETED]: chemoTranslations.status.completed,
            [STATUS.DRAFT]: chemoTranslations.status.draft,
            [STATUS.IN_PROGRESS]: chemoTranslations.status.inProgress
        };
        return labels[status] || status;
    };

    const formatDate = (date) => {
        return date ? new Date(date).toLocaleDateString('he-IL') : '-';
    };

    const getReportNumber = (report) => {
        return report.reportNumber || `#${report.id}`;
    };

    const getCreatedBy = (report) => {
        return report.createdBy || chemoTranslations.labels.unknownCreator;
    };

    const getRecordsCount = (report) => {
        return report.recordsCount || 0;
    };

    return {
        hasReports,
        getStatusStyle,
        getStatusLabel,
        formatDate,
        getReportNumber,
        getCreatedBy,
        getRecordsCount
    };
};

export default useChemoReportsList;
